/** 冷档来源按真实结构解释；未知来源仍展示原名，不丢弃原始记录。 */
const SOURCES: Record<string, [string, string]> = {
  life: ['人物大事记', '实际发生时写下的叙述；旧文字没有结构化字段时，不反推工资、出勤或离职原因。'],
  story: ['公司大事记', '公司实际事件的叙述；与人物共同关联的同一事件沿用同一个记录编号。'],
  ordinary: ['日常行动', '实际行动、时间使用和当时理由；计划或可选行动不冒充已经发生。'],
  medical: ['医疗记录', '病程、医嘱与实际服务记录；未完成医嘱不等于已经治疗或付费。'],
  death: ['死亡记录', '保存实际死亡入口和清理前可见医疗状态。并存疾病、拒诊、关联人物与调查处境不等于死因或责任认定；旧资料缺失不补猜，实际死亡日与首次离城日分开。'],
  resident_period: ['月度账本', '覆盖整个结账期间，流水按实际付款人记录；包含资产交易与借还，不能等同工资或单件事盈亏。'],
  resident_opening: ['财务观察起点', '首次保留的真实资产与当时账簿计数；观察前的流水不归到观察后的事件。'],
  firm_month: ['公司月度财报', '真实保留的月末经营摘要；旧资料没有确切结账日时不补猜日期。'],
  property_sale: ['房产交割', '同一次真实交割按单一记录编号关联买卖双方及房屋；总价、清贷和到账分别列示。'],
  academic: ['学业与资格', '真实学籍、课程、到课或资格变动；设施等级不会自动成为个人学历。'],
  origin: ['人物来历', '实际创建、出生或迁入节点；更早未观察的来历保留未知。'],
  employment: ['任职与工资', '按稳定任职编号记录应发、实发、欠薪及建筑派工。旧雇主补欠归原任职；人物与公司共享同一事件编号，不重复算一笔收入。'],
};

export const historySourceLabel = (source: string): string => SOURCES[source]?.[0] ?? source;
export const historySourceNote = (source: string): string => SOURCES[source]?.[1] ?? '此来源保留原始结构与单位；没有记录的细节不补猜。';
